/**
 * Created by emanuele on 04/02/2017.
 */
import React, {Component} from 'react'
import {Button, Icon, Modal} from 'semantic-ui-react'
import PropTypes from 'prop-types';
import RubricaSearch from './RubricaSearch';

class RubricaSearchModal extends Component {
    constructor(props) {
        super(props);
        this.state = {isOpen:false};
        this.onClickOk = this.onClickOk.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    onClickOk(soggetto){
        this.setState({ isOpen: false })
        if (this.props.onSelectSoggetto !== undefined){
            this.props.onSelectSoggetto(soggetto);
        }
    }
    onClickCancel(){
        this.setState({ isOpen: false })
    }

    handleOpen = () => {
        this.setState({ isOpen: true })
    }

    handleClose = () => {
        this.setState({ isOpen: false })
    }

    render(){
        return <Modal
            size={"large"}
            trigger={this.props.children}
            open={this.state.isOpen}
            onClose={this.handleClose}
            onOpen={this.handleOpen}
            closeIcon
        >
            <Modal.Header>{this.props.title}</Modal.Header>
            <Modal.Content>
                <RubricaSearch onSelectSoggetto={this.onClickOk}/>
            </Modal.Content>
            <Modal.Actions>
                <Button color='grey' onClick={this.onClickCancel}>
                    <Icon name='checkmark' /> Annulla
                </Button>
            </Modal.Actions>

        </Modal>
    }

}
RubricaSearchModal.PropTypes = {
    title: PropTypes.string,
    idDivisione: PropTypes.number.isRequired,
    gara: PropTypes.object.isRequired,
    onSelectSoggetto: PropTypes.func
}

RubricaSearchModal.defaultProps = {
    title: "Attenzione",
};

export default RubricaSearchModal


/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaSearchModal.js
 **/